import React, { Suspense, lazy, useRef, useState } from 'react';

import { inject } from 'mobx-react';
import { compose } from 'recompose';
import { withAppConfig } from '../../../../appConfigContext';
import appConstants from '../../../../appConstants';
import { withFeatureFlags } from '../../../../userProfile/featureFlagsContext';
import BillsGridConfig from '../../IBPlanning/ShipmentsView/ShipmentsGridConfig';
import { getSpecialNeedsOptionsWithServiceLevel } from '../../utils';
import Grid from './Grid';
import { AppLoading } from '../../../../loaders/loaders';

const ProImages = lazy(() => import("@ProImages"));

const getIBplanningConfig = ({ userData, featureFlags, configJSON }) => {
  return {
    userConfig: userData.userProfile?.columnPref,
    featureFlags: {
      IsWeightBasedRoutingEnabled: featureFlags.isFeatureEnabled(
        appConstants.features.isWeightBasedRouting
      )
    },
    terminalAccessLabel: configJSON.terminalAccessLabel,
    ROUTENAME_EDITOR_PARAMS: {},
    columnConfig: configJSON?.gridColumnConfig,
    enableFixedEquipmentSize: configJSON.enableFixedEquipmentSize,
    shouldShowTwoManInTrailerInventory: configJSON.shouldShowTwoManInTrailerInventory,
    enableNoCargoVanCustomer: configJSON.enableNoCargoVanCustomer,
    isShipementForecastView: true
  };
};

const IBBillsGrid = ({
  gridName,
  userData,
  featureFlags,
  configJSON,
  IBPlanningStore,
  ...others
}) => {
  const [proId, setProId] = useState(null);

  const config = getIBplanningConfig({ userData, featureFlags, configJSON });
  const ibBillsConfig = useRef(new BillsGridConfig({ ...config, name: gridName }));
  const ibBillsContext = useRef({
    routesList: [],
    newShipments: [],
    hasProImagesURL: Boolean(configJSON.proImagesUrl),
    specialNeedsOptions: getSpecialNeedsOptionsWithServiceLevel(
      IBPlanningStore.serviceLevelList,
      appConstants.SpecialNeedsExclusionList.shipmentGrid
    ),
    enableFMECustomer: configJSON?.enableFMECustomer,
    isShipementForecastView: true
  });

  const onCellClicked = (params) => {
    const clickedProId = params.data.proId;
    if (params.column.colId === 'proId' && clickedProId) {
      setProId(clickedProId);
    }
  };

  return (
    <>
      <Grid
        gridConfig={ibBillsConfig.current.config}
        context={ibBillsContext.current}
        onCellClicked={onCellClicked}
        {...others}
      />
      <Suspense fallback={<AppLoading />}>
        {proId && (
          <ProImages
            proNumber={proId}
            show={Boolean(proId)}
            onClose={() => {
              setProId(null);
            }}
          />
        )}
      </Suspense>
    </>
  );
};

export default compose(withFeatureFlags, withAppConfig, inject('IBPlanningStore'))(IBBillsGrid);
